import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import type { TimezoneDisplayMode } from "features/integrationsBeta/timezoneDisplay";

/**
 * Local / UTC / Client switch for run-timestamp display. "Client" renders
 * each timestamp in the owning integration's timezone (grey abbreviation
 * next to the time).
 */
export default function TimezoneDisplayToggle({
  mode,
  onChange,
}: {
  mode: TimezoneDisplayMode;
  onChange: (mode: TimezoneDisplayMode) => void;
}) {
  return (
    <ToggleButtonGroup
      size="small"
      exclusive
      value={mode}
      onChange={(_, next: TimezoneDisplayMode | null) => {
        if (next) onChange(next);
      }}
      aria-label="Timestamp timezone"
      sx={{ "& .MuiToggleButton-root": { px: 1.5, py: 0.5 } }}
    >
      <ToggleButton value="local">Local</ToggleButton>
      <ToggleButton value="utc">UTC</ToggleButton>
      <ToggleButton value="client">Client</ToggleButton>
    </ToggleButtonGroup>
  );
}
